/* global window */

import 'core-js/stable'
import 'regenerator-runtime/runtime.js'
import 'lib/polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import 'whatwg-fetch'
import App from 'components/App'
import 'styles/index.pcss'
import 'react-notifications-component/dist/theme.css'
import 'tippy.js/dist/tippy.css'
import 'animate.css'
import 'styles/animations.css'
import 'serviceWorker'
import { logException } from 'lib/errors'
import 'components/Pdf/pdf'
import LoadingIndicator from 'components/LoadingIndicator'

import 'i18n'
import moment from 'moment'

import 'images/favicon-16x16.png'
import 'images/favicon-32x32.png'
import 'images/favicon-96x96.png'
import 'images/favicon-180x180.png'
import 'images/favicon-196x196.png'

// Redirect from http to https (only required in feature branches as staging and prod handles this by default)
const match = window.location.href.match(/^http:\/\/mv-(.*)\.test\.nettix-aws.com/)
if (match) {
    logException('http protocol not supported, reloading with https...')
    const branchName = match[1].replace(/[^a-zA-Z-]/g, '') // sanitize for security
    window.location.href = `https://mv-${branchName}.test.nettix-aws.com/`
}

moment.locale('fi')

ReactDOM.render(
    <React.Suspense fallback={<LoadingIndicator />}>
        <App />
    </React.Suspense>,
    document.getElementById('root')
)
